module.exports = __webpack_public_path__ + "media/images/logo_cnet-3b103d4a9243725735c95f699ed2a88e.png";